// Edit layer style rule: Custom combo box to edit a drop-down setting

import { MenuItem, Stack, Typography } from '@mui/material';
import { theme_errorRed, theme_orange, theme_textColorBlended, theme_textColorMain } from '../../../Theme';
import { CustomSelect } from '../EditLayerStyle';



//-------------------------------------------------------------------------------
// Component props
//-------------------------------------------------------------------------------
export interface EditLayerStyleRule_Setting_Dropdown_Props
{
  name: string;
  drop_down_items: readonly string[];
  name_font_size: string;
  value?: string;
  default_value?: string;
  is_default_rule: boolean;
  OnChangeHandler: any;
  margin_left?: number;
  width?: string;
}

//-------------------------------------------------------------------------------
// Edit layer style rule: Custom combo box to edit a drop-down setting
//-------------------------------------------------------------------------------
export function EditLayerStyleRule_Setting_Dropdown(props: EditLayerStyleRule_Setting_Dropdown_Props) 
{








  


  // Main render

  return (

    <Stack sx={{ ml: props.margin_left }}>
      
      <Typography sx={{ fontSize: props.name_font_size, color: theme_textColorBlended+'B0' }}>
        {props.name}
      </Typography>
      
      <CustomSelect variant='standard' size='small'
                    value={props.value} onChange={props.OnChangeHandler}
                    sx={{ width: props.width, fontSize: props.name_font_size }}>

        {props.drop_down_items.map(item =>
          <MenuItem key={item} value={item}>
            {item.toLowerCase()==='none' 
              ?
                <Typography sx={{ fontSize: '0.9rem', color: theme_textColorMain+'45' }}>
                  {props.is_default_rule === true ? 'Not Set' : 'Default'}
                </Typography>
              :
                <Typography sx={{ fontSize: '0.9rem', color: theme_textColorMain+'C0', textTransform: 'capitalize' }}>
                  {item}
                </Typography>
            }
          </MenuItem>

        )}

      </CustomSelect>

      {RenderDefaultValue_Dropdown(props.value, props.default_value, props.is_default_rule, 'None')}

    </Stack>
  )
}




//-------------------------------------------------------------------------------
// Renders the default value/status.
// This version handles all numerical values, as well as enums which have a 
// "none" option.
//-------------------------------------------------------------------------------
export function RenderDefaultValue_Dropdown(value: string | undefined, value_default: string | undefined, 
                                            is_default_rule: boolean, special_value_to_inherit: string)
{
  // If this is happening inside the "Default Rule", we show nothing
  if(is_default_rule===true)
    return null;

  // If the value IS the special inherit value, we show nothing
  if(value !== undefined && value.toLocaleLowerCase() !== special_value_to_inherit.toLocaleLowerCase())
    return null;

  return (

    <Stack direction='row' sx={{ alignItems: 'center' }}>

      <Typography sx={{ fontSize: '0.7rem', color: theme_textColorMain+'70'}}>
        Default:
      </Typography>

      {value_default !== undefined && value_default.toLocaleLowerCase() !== special_value_to_inherit.toLocaleLowerCase()
        ?
          // We have a default value - show it
          <Typography sx={{ ml: 0.5, fontSize: '0.7rem', color: theme_orange+'A0', textTransform: 'capitalize' }}>
            {value_default}
          </Typography>
        : // No default value is set - show a warning
          <Typography sx={{ ml: 0.5, fontSize: '0.7rem', color: theme_errorRed}}>
            Not Set
          </Typography>
      }

    </Stack>
  )
}
